//* Browser validation: IE is not supported
import Bowser from 'bowser';

const validateBrowser = () => {
    const browser = Bowser.getParser(window.navigator.userAgent);

    //* IE is not supported
    if (browser?.parsedResult?.browser?.name === 'Internet Explorer') {
        window.location = '/general/unsupported-ie.php';
    }
};

export default validateBrowser;
